export default class SendPassCodeResponse {
  constructor(obj) {
    if (!obj) obj = {};
    this.success = obj.success ? obj.success : false;
    this.partialCode = obj.partialCode ? obj.partialCode : null;
  }
}
